// 🔧 COOKIE CONSENT FIX
// Ensures only one cookie banner shows and doesn't interfere with product images

(function() {
  'use strict';

  // Cookie consent fix initialized

  // FIX COOKIE CONSENT OVERLAY - TARGETED FIX
  function fixCookieConsent() {
    // Find only specific cookie consent elements
    const cookieBanners = document.querySelectorAll('#t4s-popup__cookies-law, div[id*="cookie-consent"], div[id*="cookie_banner"], div[id*="gdpr-banner"], div[id*="privacy-banner"], div[id*="compliance-banner"], div[class*="cookie-consent"], div[class*="cookie_banner"], div[class*="gdpr-banner"], div[class*="privacy-banner"], div[class*="compliance-banner"]');
    
    // Keep only the first one, remove others
    cookieBanners.forEach((banner, index) => {
      if (index > 0) {
        banner.remove();
      }
    });

    // Ensure the remaining banner is small and doesn't interfere
    const remainingBanner = document.querySelector('#t4s-popup__cookies-law, div[id*="cookie-consent"], div[id*="cookie_banner"], div[id*="gdpr-banner"], div[id*="privacy-banner"], div[id*="compliance-banner"], div[class*="cookie-consent"], div[class*="cookie_banner"], div[class*="gdpr-banner"], div[class*="privacy-banner"], div[class*="compliance-banner"]');
    if (remainingBanner) {
      
      // Make it small and fixed at bottom
      remainingBanner.style.zIndex = '999';
      remainingBanner.style.position = 'fixed';
      remainingBanner.style.bottom = '0';
      remainingBanner.style.left = '0';
      remainingBanner.style.right = '0';
      remainingBanner.style.top = 'auto';
      remainingBanner.style.maxHeight = '50px';
      remainingBanner.style.overflow = 'hidden';
      remainingBanner.style.fontSize = '10px';
      remainingBanner.style.padding = '6px 12px';
      remainingBanner.style.background = 'rgba(255, 255, 255, 0.95)';
      remainingBanner.style.borderTop = '1px solid #e0e0e0';
      remainingBanner.style.boxShadow = '0 -2px 10px rgba(0,0,0,0.1)';
      
      // Make only text elements within this banner small
      const textElements = remainingBanner.querySelectorAll('p, div, span, h1, h2, h3, h4, h5, h6');
      textElements.forEach(element => {
        element.style.fontSize = '9px';
        element.style.lineHeight = '1.2';
        element.style.margin = '2px 0';
        element.style.maxWidth = '70%';
        element.style.overflow = 'hidden';
        element.style.textOverflow = 'ellipsis';
        element.style.whiteSpace = 'nowrap';
      });
      
      // Make only buttons within this banner small
      const buttons = remainingBanner.querySelectorAll('button, a');
      buttons.forEach(button => {
        button.style.fontSize = '9px';
        button.style.padding = '3px 6px';
        button.style.margin = '1px 2px';
        button.style.borderRadius = '2px';
        button.style.minHeight = '20px';
        button.style.maxHeight = '20px';
        button.style.lineHeight = '1';
      });
    }
  }

  // FIX SHINE TRUST COOKIE BANNER
  function fixShineTrustCookieBanner() {
    
    // Look for Shine Trust cookie banner
    const shineTrustBanner = document.querySelector('[class*="shine-trust"][class*="cookie"], [id*="shine-trust"][id*="cookie"]');
    
    if (shineTrustBanner) {
      
      // Ensure it doesn't interfere with product images
      shineTrustBanner.style.zIndex = '998';
      shineTrustBanner.style.position = 'fixed';
      shineTrustBanner.style.bottom = '0';
      shineTrustBanner.style.left = '0';
      shineTrustBanner.style.right = '0';
      shineTrustBanner.style.top = 'auto';
    }
  }

  // APPLY ALL FIXES
  function applyAllFixes() {
    
    fixCookieConsent();
    fixShineTrustCookieBanner();
    
  }

  // RUN ONCE
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyAllFixes);
  } else {
    applyAllFixes();
  }

  // Also run on window load
  window.addEventListener('load', function() {
    setTimeout(applyAllFixes, 500);
  });

})(); 